import Fixed from './FixedLayout';
import Simple from './SimpleLayout';

export default {
	Fixed,
	Simple
}
